import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IDescriptionWindowState } from '../../types/descriptionWindow'
import {
    DESCRIPTION_WINDOW_INIT_COORDINATES,
    DESCRIPTION_WINDOW_INIT_SIZE,
} from '../../components/DescriptionWindow/consts'

const initialState: IDescriptionWindowState = {
    show: false,
    size: DESCRIPTION_WINDOW_INIT_SIZE,
    coordinates: DESCRIPTION_WINDOW_INIT_COORDINATES,
    data: {
        header: '',
        description: '',
    },
}

const descriptionWindowSlice = createSlice({
    name: 'descriptionWindowSlice',
    initialState,
    reducers: {
        show: (state) => {
            state.show = true
        },
        hide: (state) => {
            state.show = false
            state.data = { header: '', description: '' }
        },
        changeCoordinates: (
            state,
            action: PayloadAction<{ x: number; y: number }>
        ) => {
            state.coordinates = { x: action.payload.x, y: action.payload.y }
        },
        changeSize: (
            state,
            action: PayloadAction<{ width: number; height: number }>
        ) => {
            state.size = action.payload
        },
        setDescriptionData: (
            state,
            action: PayloadAction<{ header: string; description: string }>
        ) => {
            state.data = action.payload
        },
    },
})

export const { actions: descriptionWindowActions } = descriptionWindowSlice
export const { reducer: descriptionWindowReducer } = descriptionWindowSlice
